import Button from "components/common/Button";
//import { ReactComponent as PinIcon } from "assets/PinIcon.svg";
import { Radio, TextField } from "@mui/material";
import ThemeContext from "components/app/Context";
import DialogFormation from "components/common/DialogFormation";
import { saveFilterByType, setSavedFilter, setView } from "components/common/Filters/Filters.slice";
import { filterPage, filterPayloadForSelectAllFeature } from "components/common/Filters/FiltersHelper";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Typography from "components/common/Typography";
import { updateInncodeUploadList } from "components/features/SME/sme.slice";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { setSelectedMyList } from "utils/CommonFunctions";
import { responseTypes } from "utils/Types";
import { setCreateListError, setDialog, setSelectedList } from "../../Corp/CorpUser.Slice";
import "./saveList.scss";

export default function SaveList() {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const location = useLocation();
  const navigate = useNavigate();
  const { isMobileScreen } = useContext(ThemeContext);
  const [selectedValue, setSelectedValue] = useState<string>("");

  const isFromManageSuggestion = String(location?.pathname?.split("/")[1])?.toLowerCase() === "managesuggestions";
  const globalFiltersforDashboardDisplay = useAppSelector((state) => state.globalFilters[filterPage.dashboardDisplay]);
  const globalFiltersforManageSuggestionsDisplay = useAppSelector(
    (state) => state.globalFilters[filterPage.manageSuggestionsDisplay]
  );

  const globalFiltersforPage = isFromManageSuggestion
    ? globalFiltersforManageSuggestionsDisplay
    : globalFiltersforDashboardDisplay;

  const filters = globalFiltersforPage?.isFilterApplied
    ? globalFiltersforPage?.modifiedFilter
    : globalFiltersforPage?.defaultFilter;

  const [payload, setPayload] = useState<any>({ title: "", description: "" });
  const overview = useAppSelector((state) => state.CorpDashboard.myView.properties.overview);
  const allSuggestedInncodes = useAppSelector((state) => state.manageSuggestions.allSuggestedInncodes);
  const isConsultant = useAppSelector((state) => state.app.loggedInUserDetails.isConsultant);
  const isOpen = useAppSelector((state) => state.CorpDashboard.dialogs.saveList.isOpen);
  const createListError = useAppSelector((state) => state.CorpDashboard.createListError);

  const innCodes = isFromManageSuggestion
    ? allSuggestedInncodes
    : overview?.inncodes?.split(",").map((code: any) => code.trim());

  const filtersToSave = isFromManageSuggestion
    ? filters?.filter((item: any) => !["staticListIds", "hltId"].includes(item?.key))
    : filters;

  useEffect(() => {
    setSelectedValue("");
    setPayload({ title: "", description: "" });
    dispatch(
      setCreateListError({
        isError: false,
        message: "",
        isInputError: false
      })
    );
  }, [isOpen]);

  const handleClose = () => {
    dispatch(setDialog({ dialogName: "saveList", isOpen: false, data: {} }));
  };

  const handleRadioCheck = (value: string) => {
    setPayload({ title: "", description: "" });
    setSelectedValue(value);
    dispatch(
      setCreateListError({
        isError: false,
        message: "",
        isInputError: false
      })
    );
  };

  const isFilterChecked = selectedValue === "filter";
  const isPropertyChecked = selectedValue === "property";
  const isConsultantChecked = selectedValue === "consultant";

  const getView = (title: string, description: string, view: string) => {
    return (
      <div className={view === selectedValue ? "child-view-conatiner-active" : "child-view-conatiner"}>
        <div className="child-view-conatiner-row">
          <Radio
            checked={
              view === "filter" ? isFilterChecked : view === "property" ? isPropertyChecked : isConsultantChecked
            }
            onChange={() => handleRadioCheck(view)}
          />
          <Typography color={tokens.Text.General.PrimaryHeadline} variant={"body2"} showBold>
            {title}
          </Typography>
        </div>
        <Typography color={tokens.Text.General.PrimaryBody} variant={"body2"}>
          {description}
        </Typography>
        {view === selectedValue && getActiveView(view)}
      </div>
    );
  };

  const getActiveView = (view: string) => {
    return (
      <div className="active-view">
        <div className="text-field-styling">
          <Typography variant="body2" className="list-name-label" color={tokens.Text.General.Secondary}>
            <span style={{ color: "red" }}>*</span>
            {translate("list.name.label")}
          </Typography>
          <TextField
            error={createListError.isInputError}
            className="list-desc-inputs"
            onChange={(value: any) => setPayload({ ...payload, title: value.target.value })}
            placeholder="List name here"
          />
          {createListError.isInputError && createListError.message === "The list name already exists" && (
            <Typography color="red" variant={"label"}>
              {createListError.message}
            </Typography>
          )}
        </div>
        {view !== "filter" && (
          <div className="text-field-styling">
            <Typography variant="body2" className="list-name-label" color={tokens.Text.General.Secondary}>
              {translate("common.description")}
            </Typography>
            <TextField
              className="list-desc-desc"
              multiline
              rows={4}
              onChange={(value: any) => setPayload({ ...payload, description: value.target.value })}
              placeholder="Description here"
            />
          </div>
        )}
      </div>
    );
  };

  const checkNoRelevantData = (data: any, errorMessage: string) => {
    if (!data?.length) {
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          variant: "error",
          setState: setFeedbackDetails({ shouldShow: false }),
          message: errorMessage
        })
      );
      return true;
    }
    return false;
  };

  const checkAndRedirect = (res: any) => {
    dispatch(setView("MyList"));
    dispatch(setSelectedList({}));
    setSelectedMyList(dispatch, res, isFilterChecked ? "dynamic" : isPropertyChecked ? "static" : "consultant");
    dispatch(
      setCreateListError({
        isError: false,
        message: "",
        isInputError: false
      })
    );
    navigate(`/myLists`, {
      state: {
        fromDashboard: true
      }
    });

    handleClose();
  };

  const handleSubmit = async () => {
    let props;
    if (isFilterChecked) {
      if (checkNoRelevantData(filterPayloadForSelectAllFeature(filtersToSave), "No relevant filters found.")) return;
      props = {
        dynamic: [
          {
            name: payload?.title,
            filters: filterPayloadForSelectAllFeature(filtersToSave)
          }
        ]
      };
    } else if (isPropertyChecked) {
      if (checkNoRelevantData(innCodes, "No inncode found.")) return;
      props = {
        static: [
          {
            name: payload?.title,
            description: payload?.description,
            filters: [
              {
                key: "inncode",
                options: innCodes
              }
            ]
          }
        ]
      };
    } else {
      if (checkNoRelevantData(innCodes, "No inncode found.")) return;
      props = {
        name: payload?.title,
        description: payload?.description,
        mappings: innCodes?.map((item: string) => {
          return { innCode: item };
        })
      };
      const response = await dispatch(updateInncodeUploadList(props));
      if (response?.payload?.errors) {
        if (response?.payload?.errors[0]?.source !== "List Name")
          dispatch(
            setFeedbackDetails({
              shouldShow: true,
              variant: "error",
              setState: setFeedbackDetails({ shouldShow: false }),
              message: response?.payload?.errors[0]?.detail
            })
          );
        else
          dispatch(
            setCreateListError({
              isError: true,
              message: response?.payload?.errors?.[0]?.detail,
              isInputError: true
            })
          );
      } else if (response?.payload?.status < responseTypes.success_threshold) {
        dispatch(
          setSavedFilter({
            name: "consultant",
            data: response?.payload?.scList
          })
        );
        checkAndRedirect(response?.payload?.scList);
        return;
      }
      return;
    }

    const res = await dispatch(saveFilterByType(props));
    if (res?.payload?.data?.errors) {
      dispatch(
        setCreateListError({
          isError: true,
          message: res?.payload?.data?.errors?.[0]?.detail,
          isInputError: true
        })
      );
    } else if (res.payload?.status === 200)
      checkAndRedirect(
        res?.payload?.[isFilterChecked ? "dynamic" : "static"]?.find((item: any) => item?.name === payload?.title)
      );
  };

  return (
    <>
      {isOpen && (
        <DialogFormation
          title={translate("dashboard.saveListTitle")}
          openDialog={isOpen}
          handleClose={handleClose}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleClose} width={isMobileScreen ? "50%" : "25%"} />
              <Button
                disabled={!payload?.title}
                variant="primary"
                label="Save"
                onClick={() => handleSubmit()}
                width={isMobileScreen ? "50%" : "25%"}
              />
            </div>
          }
        >
          <div className="parent-view-container">
            {getView(translate("dashboard.saveFilters"), translate("dashboard.saveFiltersDescription"), "filter")}
            {getView(translate("dashboard.saveProperty"), translate("dashboard.savePropertyDescription"), "property")}
            {isConsultant &&
              getView(
                translate("dashboard.saveConsultant"),
                translate("dashboard.saveConsultantDescription"),
                "consultant"
              )}
          </div>
        </DialogFormation>
      )}
    </>
  );
}
